import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import WalletConnect from '../components/wallet/WalletConnect';
import { findWalletUserByWalletId } from '../services/walletService';

const WalletConnectionPage = () => {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [walletInfo, setWalletInfo] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchWalletInfo = async () => {
      if (currentUser && currentUser.walletConnected && currentUser.walletId) {
        try {
          setLoading(true);
          const walletUser = await findWalletUserByWalletId(currentUser.walletId);
          if (walletUser) {
            setWalletInfo(walletUser);
          }
        } catch (error) {
          console.error('Error fetching wallet info:', error);
          setError('Hiba történt a wallet információk lekérése során.');
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    fetchWalletInfo();
  }, [currentUser]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900">Wallet Kapcsolat Kezelése</h2>
        <p className="mt-1 text-sm text-gray-500">
          Itt kezelheti a wallet fiókja kapcsolatát az Előny Klub fiókjával.
        </p>
      </div>

      {loading ? (
        <div className="text-center my-12">
          <svg className="animate-spin h-10 w-10 text-indigo-600 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <p className="mt-2 text-gray-600">Adatok betöltése...</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="md:col-span-2">
            <WalletConnect />

            {walletInfo && walletInfo.elonyKlubConnected && (
              <div className="bg-white rounded-lg shadow p-4 mb-4">
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-lg font-semibold text-gray-800">Wallet Tranzakciók</h3>
                </div>
                {/* Itt jeleníthetjük meg a wallet tranzakciókat, ha implementálva van */}
                <div className="bg-blue-50 border border-blue-200 text-blue-700 px-4 py-3 rounded">
                  A wallet tranzakciók hamarosan elérhetőek lesznek ezen a felületen.
                </div>
              </div>
            )}

            <div className="bg-white rounded-lg shadow p-4 mb-4">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold text-gray-800">Wallet Előnyök</h3>
              </div>
              <h4 className="font-medium text-gray-700 mb-2">Miért érdemes összekapcsolni a wallet fiókját?</h4>
              <ul className="list-disc pl-5 space-y-1 text-gray-600">
                <li>Egyszerűbb és gyorsabb tranzakciók</li>
                <li>Speciális kedvezmények wallet felhasználóknak</li>
                <li>Tokenek könnyű kezelése</li>
                <li>Biztonságos fizetési lehetőségek</li>
                <li>Valós idejű egyenleg követés</li>
              </ul>
            </div>
          </div>

          <div className="md:col-span-1">
            <div className="bg-white rounded-lg shadow p-4 mb-4">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold text-gray-800">Gyakori Kérdések</h3>
              </div>
              <div className="space-y-4">
                <div>
                  <h4 className="font-medium text-gray-700 mb-1">Mi az a wallet?</h4>
                  <p className="text-gray-600 text-sm">A wallet egy digitális pénztárca, amely lehetővé teszi a kriptovaluták és tokenek tárolását és kezelését.</p>
                </div>
                <div>
                  <h4 className="font-medium text-gray-700 mb-1">Hogyan kapcsolhatom össze a wallet fiókomat?</h4>
                  <p className="text-gray-600 text-sm">Egyszerűen adja meg a wallet azonosítóját a kapcsolat létrehozásához.</p>
                </div>
                <div>
                  <h4 className="font-medium text-gray-700 mb-1">Biztonságos az összekapcsolás?</h4>
                  <p className="text-gray-600 text-sm">Igen, az összekapcsolás biztonságos, és bármikor megszüntetheti a kapcsolatot.</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow p-4 mb-4">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold text-gray-800">Segítség</h3>
              </div>
              <p className="text-gray-600 text-sm mb-4">
                Ha kérdése van a wallet kapcsolattal kapcsolatban, vagy segítségre van szüksége, 
                kérjük, vegye fel a kapcsolatot ügyfélszolgálatunkkal.
              </p>
              <p className="text-gray-700 text-sm mb-1">
                <span className="font-medium">Email:</span> support@elonyklub.hu
              </p>
              <p className="text-gray-700 text-sm">
                <span className="font-medium">Telefon:</span> +36 1 234 5678
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WalletConnectionPage;